import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import {
  fetchProspectsRoutine,
  changeProspectStatusRoutine,
  fetchProspectCountersRoutine
} from '../../routines';
import {
  getProspects,
  updateStatus,
  getProspectCounters
} from '../../../../services/prospectsService';
import { Routine } from 'redux-saga-routines';
import { IAppState } from '../../../../common/models/store/IAppState';

function* getProspectsRequest({ payload }: Routine<any>) {
  try {
    const response = yield call(getProspects, payload);
    const data = {
      ...response,
      reset: !payload.from
    };
    yield put(fetchProspectsRoutine.success(data));
  } catch {
    yield put(fetchProspectsRoutine.failure());
  }
}

function* watchGetProspectsRequest() {
  yield takeEvery(fetchProspectsRoutine.TRIGGER, getProspectsRequest);
}

function* changeProspectStatus({ payload }: Routine<any>) {
  try {
    yield call(updateStatus, payload.data);
    yield put(changeProspectStatusRoutine.success(payload));

    const { filter } = yield select(({ dashboard: { prospects } }: IAppState) => prospects);
    yield put(fetchProspectCountersRoutine.trigger(filter));
    yield put(fetchProspectsRoutine.trigger(filter));
  } catch {
    yield put(changeProspectStatusRoutine.failure());
  }
}

function* watchChangeProspectStatus() {
  yield takeEvery(changeProspectStatusRoutine.TRIGGER, changeProspectStatus);
}

function* getCountersReq({ payload }: Routine<any>) {
  try {
    const response = yield call(getProspectCounters, payload);
    yield put(fetchProspectCountersRoutine.success(response));
  } catch {
    yield put(fetchProspectCountersRoutine.failure());
  }
}

function* watchGetCountersReq() {
  yield takeEvery(fetchProspectCountersRoutine.TRIGGER, getCountersReq);
}

export default function* prospectsSaga() {
  yield all([
    watchGetProspectsRequest(),
    watchChangeProspectStatus(),
    watchGetCountersReq()
  ]);
}
